
import { useState } from "react";
import { useToast } from "@/hooks/use-toast";

export function useSermonDeletion(
  deleteSermonPlan: (id: string) => Promise<boolean>,
  fetchData: () => void
) {
  const { toast } = useToast();
  const [isDeleting, setIsDeleting] = useState(false);
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);
  const [sermonToDelete, setSermonToDelete] = useState<string | null>(null);

  const confirmDelete = async () => {
    if (!sermonToDelete) return;
    
    try {
      setIsDeleting(true);
      const success = await deleteSermonPlan(sermonToDelete);
      if (success) {
        fetchData(); // Refresh the data
        toast({
          title: "Success",
          description: "Sermon plan deleted successfully",
        });
      }
    } catch (error: any) {
      console.error("Error deleting sermon plan:", error);
      toast({
        title: "Error",
        description: error.message || "Failed to delete sermon plan",
        variant: "destructive",
      });
    } finally {
      setIsDeleting(false);
      setShowDeleteDialog(false);
      setSermonToDelete(null);
    }
  };

  const handleDelete = (id: string) => {
    setSermonToDelete(id);
    setShowDeleteDialog(true);
  };

  const cancelDelete = () => {
    setShowDeleteDialog(false);
    setSermonToDelete(null);
  };

  return {
    handleDelete,
    isDeleting,
    showDeleteDialog,
    setShowDeleteDialog,
    confirmDelete,
    cancelDelete
  };
}
